import React, { HTMLProps } from 'react';
import { StyledContainer } from './styles';

const IndeterminateCheckbox = ({
  indeterminate,
  className = '',
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>): JSX.Element => {
  const ref = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (!ref.current) {
      return;
    }

    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate, rest.checked]);

  return (
    <StyledContainer>
      <input type="checkbox" ref={ref} className={className + ' cursor-pointer'} {...rest} />
    </StyledContainer>
  );
};

export default IndeterminateCheckbox;
